import React, { Component } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { RotateLoader } from "react-spinners";
import { isMobile } from "react-device-detect";

export class FormTime extends Component {
  constructor(props) {
    super(props);

    var dateTimes = {};
    var dates = [];
    Object.entries(this.props.values.availableCalendar).forEach((e) => {
      let date = e[0];
      let times = e[1];
      dateTimes[date] = [];
      dates.push(new Date(date));
      times.forEach((time) => {
        dateTimes[date].push(new Date(date + " " + time));
      });
    });
    this.state = {
      loading: true,
      dateTimes: dateTimes,
      dates: dates.sort((a, b) => a - b),
    };
  }

  continue = (e) => {
    e.preventDefault();
    this.props.nextStep();
  };

  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  isInArray = (array, value) => {
    return !!array.find((item) => {
      return item.getTime() === value.getTime();
    });
  };

  handleDateChange = (date) => {
    if (date === undefined) {
      this.props.handleChange({ date: this.state.dateTimes[this.state.dates[0].toLocaleDateString("en-US")][0] });
    } else {
      const possibleDate = new Date(date.toLocaleDateString("en-US") + " " + date.toLocaleTimeString());
      if (!this.isInArray(this.state.dateTimes[date.toLocaleDateString("en-US")], possibleDate)) {
        this.props.handleChange({ date: this.state.dateTimes[date.toLocaleDateString("en-US")][0] });
      }
    }
  };

  componentDidMount() {
    this.handleDateChange(this.state.date);
    this.setState({
      loading: false,
    });
  }

  render() {
    const { values, handleChange } = this.props;
    console.debug(values);
    return (
      <React.Fragment>
        <h3>Select Date/Time</h3>
        <hr />
        <Row>
          <Col>
            {!this.state.loading && (
              <Form onSubmit={this.continue}>
                <Form.Group controlId="formTime" className="text-center">
                  <DatePicker
                    className="form-control"
                    inline
                    name="date"
                    monthsShown={isMobile ? 1 : 1}
                    selected={values.date}
                    showTimeSelect
                    dateFormat="m/d/Y H:i"
                    timeFormat="h:mm aa"
                    onSelect={this.handleDateChange}
                    timeIntervals={5}
                    onChange={(e) =>
                      handleChange({
                        date: e,
                      })
                    }
                    includeDates={this.state.dates}
                    highlightDates={values.date + 5}
                    includeTimes={Object.values(this.state.dateTimes[values.date.toLocaleDateString("en-US")])}
                  />
                </Form.Group>
                <h2 className="text-center">
                  {values.date.toLocaleString("en-US", {
                    weekday: "short",
                    month: "short",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                  })}
                </h2>
                <Button size="lg" block variant="primary" type="submit">
                  Review
                </Button>
              </Form>
            )}
            <div className="text-center loader">
              <RotateLoader color={"#337ab7"} loading={this.state.loading} />
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default FormTime;
